import script from "./Germany.vue?vue&type=script&setup=true&lang=js"
export * from "./Germany.vue?vue&type=script&setup=true&lang=js"

import "./Germany.vue?vue&type=style&index=0&id=2ba1a848&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ba1a848"]])

export default __exports__